import { createAction, createActionGroup, props } from '@ngrx/store';
import {
  AssetAllocation,
  CashAccountId,
  DepositaryMobileBank,
  FavoriteNumbers,
  Performance,
  PerformanceEnum,
  Portfolio,
  PortfolioInstrument,
  PortfolioNumber,
  Transaction
} from '@qvs/core';

const source = 'Portfolio';
const prefix = `[${source}]`;

export const toggleFavoritePortfolio = createAction(`${prefix} Toggle Favorite Portfolio`, props<{ portfolio: Portfolio }>());

export const toggleFavoritePortfolioSuccess = createAction(
  `${prefix} Toggle Favorite Portfolio Success`,
  props<{ favoriteNumbers: FavoriteNumbers }>()
);

export const setCurrentPortfolio = createAction(`${prefix} Set Current Portfolio`, props<{ portfolio: Portfolio }>());

export const loadPortfolios = createAction(`${prefix} Load Portfolios`);

export const setCreditCardPortfolioIds = createAction(
  '[Portfolio] Set Credit Card Portfolio Ids',
  props<{ creditCardPortfolioIds: string[] }>()
);

export const initialLoadPortfolios = createAction(`${prefix} Initial Load Portfolios`);

export const loadPortfoliosSuccess = createAction(`${prefix} Load Portfolios Success`, props<{ portfolios: Portfolio[] }>());

export const loadPortfoliosFailure = createAction(`${prefix} Load Portfolios Failure`);

export const loadPortfolio = createAction(`${prefix} Load Portfolio`, props<{ portfolioNumber: PortfolioNumber }>());

export const loadPortfolioSuccess = createAction(`${prefix} Load Portfolio Success`, props<{ portfolio: Portfolio }>());

export const loadPortfolioFailure = createAction(
  `${prefix} Load Portfolio Failure`,
  props<{ portfolioNumber: PortfolioNumber }>()
);

export const loadDepositaryBanks = createAction(`${prefix} Load Depositary Banks`);

export const loadDepositaryBanksSuccess = createAction(
  `${prefix} Load Depositary Banks Success`,
  props<{ depositaryBanks: DepositaryMobileBank[] }>()
);

export const loadDepositaryBanksFailure = createAction(`${prefix} Load Depositary Banks Failure`);

export const setCurrentCashAccount = createAction(
  `${prefix} Toggle Current Cash Account`,
  props<{ portfolioNumber: PortfolioNumber; cashAccountId?: CashAccountId }>()
);

export const setCurrentInstrument = createAction(
  `${prefix} Set Current Instrument`,
  props<{ instrument: PortfolioInstrument }>()
);

export const setCurrentAssetAllocation = createAction(
  `${prefix} Set Current Asset Allocation`,
  props<{ assetAllocation: AssetAllocation }>()
);

export const lazyLoadTransactionsForCashAccounts = createAction(
  `${prefix} Lazy Load Transactions For Cash Account`,
  props<{ portfolioNumber: PortfolioNumber; cashAccountId: CashAccountId; transactionsCount: number }>()
);

export const loadTransactionsForCashAccountsSuccess = createAction(
  `${prefix} Load Transactions For Cash Account Success`,
  props<{ portfolioNumber: PortfolioNumber; cashAccountId: CashAccountId; transactions: Transaction[] }>()
);

export const loadTransactionsForCashAccountsSkip = createAction(`${prefix} Load Transactions For Cash Account Skip`);

export const loadTransactionsForCashAccountsFailure = createAction(
  `${prefix} Load Transactions For Cash Account Failure`,
  props<{ portfolioNumber: PortfolioNumber; cashAccountId: CashAccountId }>()
);

export const { loadYtdPerformance, loadYtdPerformanceSuccess, loadYtdPerformanceFailure } = createActionGroup({
  source,
  events: {
    'load ytd performance': props<{ portfolioNumber: PortfolioNumber }>(),
    'load ytd performance success': props<{ performance: Performance }>(),
    'load ytd performance failure': props<{ portfolioNumber: PortfolioNumber }>()
  }
});

export const { loadPreviousYearPerformance, loadPreviousYearPerformanceSuccess, loadPreviousYearPerformanceFailure } =
  createActionGroup({
    source,
    events: {
      'load previous year performance': props<{ portfolioNumber: PortfolioNumber }>(),
      'load previous year performance success': props<{ performance: Performance }>(),
      'load previous year performance failure': props<{ portfolioNumber: PortfolioNumber }>()
    }
  });

export const { loadInceptionPerformance, loadInceptionPerformanceSuccess, loadInceptionPerformanceFailure } = createActionGroup({
  source,
  events: {
    'load inception performance': props<{ portfolioNumber: PortfolioNumber }>(),
    'load inception performance success': props<{ performance: Performance }>(),
    'load inception performance failure': props<{ portfolioNumber: PortfolioNumber }>()
  }
});

export const setPortfolioPerformanceTimeRange = createAction(
  `${prefix} Set Performance Time Range`,
  props<{ portfolioPerformanceTimeRange: PerformanceEnum }>()
);
